import React from 'react';
import { Box, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/FutureSection/FutureSection.styles';

const FutureSectionSkeleton: React.FC = () => {
  return (
    <StyledBox>
      <Box className="FSOverlay" />
      <Box className="FSContent">
        {/* Heading */}
        <Skeleton variant="text" width="70%" height={48} sx={{ mb: 5 }} />

        {/* First Paragraph */}
        <Box sx={{ mb: 1.5 }}>
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="98%" height={24} />
          <Skeleton variant="text" width="95%" height={24} />
          <Skeleton variant="text" width="92%" height={24} />
        </Box>

        {/* Second Paragraph */}
        <Box>
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="98%" height={24} />
          <Skeleton variant="text" width="95%" height={24} />
          <Skeleton variant="text" width="90%" height={24} />
        </Box>
      </Box>
    </StyledBox>
  );
};

export { FutureSectionSkeleton };
